/* eslint-env jest */
import { stampEntryMethod } from './stampEntryMethod';

// The bug this pins: `customer.cart.isDirty is not a function`, thrown on the
// Continue button of the access-code form.
//
// A cart restored from localStorage is a PLAIN OBJECT -- CustomerContext's
// rehydrate leaves the model reconstruction commented out, and the G1 self-heal
// only replaces a cart that is dead. So a returning visitor with a live cart
// carries attributes and no methods, and the unguarded isDirty() call took the
// whole submit down.
describe('stampEntryMethod', () => {
  const modelCart = (attrs = {}) => ({
    id: 7,
    isDirty: jest.fn(() => true),
    save: jest.fn(),
    ...attrs,
  });

  describe('a real Cart model', () => {
    it('stamps the entry method and saves', () => {
      const cart = modelCart();

      expect(stampEntryMethod(cart)).toBe(true);
      expect(cart.entryMethod).toBe('typed_code');
      expect(cart.save).toHaveBeenCalled();
    });

    it('records where the shopper came from when we know', () => {
      const cart = modelCart();

      stampEntryMethod(cart, { createdLocation: 'sitting_cards' });

      expect(cart.createdLocation).toBe('sitting_cards');
    });

    // This is the highest-traffic entry form; a resubmit or a typo must not
    // re-save an unchanged cart.
    it('does not save when nothing changed', () => {
      const cart = modelCart({ isDirty: jest.fn(() => false) });

      expect(stampEntryMethod(cart)).toBe(false);
      expect(cart.save).not.toHaveBeenCalled();
    });
  });

  describe('a cart rehydrated from localStorage', () => {
    // The crash, exactly: attributes but no methods.
    const plainCart = () => ({ id: 7, createdLocation: null, entryMethod: null });

    it('does not throw', () => {
      expect(() => stampEntryMethod(plainCart())).not.toThrow();
    });

    it('reports that nothing was saved, rather than pretending it was', () => {
      expect(stampEntryMethod(plainCart())).toBe(false);
    });

    // Still stamped in memory: if anything later swaps in a real model for the
    // same row, the value is already there to persist.
    it('still stamps the value locally', () => {
      const cart = plainCart();

      stampEntryMethod(cart, { createdLocation: 'proofs' });

      expect(cart.entryMethod).toBe('typed_code');
      expect(cart.createdLocation).toBe('proofs');
    });

    // Half a model is the same hazard as none.
    it('does not save a cart that can report dirty but cannot save', () => {
      const cart = { id: 7, isDirty: () => true };

      expect(() => stampEntryMethod(cart)).not.toThrow();
      expect(stampEntryMethod(cart)).toBe(false);
    });
  });

  it('does nothing at all without a cart', () => {
    expect(stampEntryMethod(null)).toBe(false);
    expect(stampEntryMethod(undefined)).toBe(false);
  });
});
